import React from 'react';
import { Link } from 'react-router-dom';

/**
 * Compact registration promo for the profile right rail.
 */
function RegistrationPromoCard({ season, showDivider = true }) {
  if (!season) return null;

  const registerUrl = `/league/${season.id}/register/`;
  const feeLabel =
    season.current_fee != null && season.current_fee !== ''
      ? `$${Number(season.current_fee).toFixed(2)}`
      : null;

  return (
    <div className={showDivider ? 'mb-3 pb-3 border-bottom' : 'mb-3'}>
      <div
        className="position-relative rounded mb-2 overflow-hidden"
        style={{
          background:
            'linear-gradient(145deg, rgba(13, 110, 253, 0.12), rgba(25, 135, 84, 0.1))',
        }}
      >
        <img
          className="img-fluid"
          src={
            season.league_logo ||
            '/static/images/kb_static/lemont_rec_leagues_circle.png'
          }
          alt=""
          style={{
            width: '100%',
            height: '140px',
            objectFit: 'contain',
            padding: '1rem',
            display: 'block',
          }}
        />
        <span className="badge bg-success position-absolute top-0 end-0 m-2">
          Open
        </span>
      </div>
      <h3 className="h6 mb-0">{season.league_name}</h3>
      <p className="mb-2 small">{season.name}</p>
      {season.league_location && (
        <p className="small text-muted mb-1">
          <i className="bi bi-geo-alt pe-1" aria-hidden="true"></i>
          {season.league_location}
        </p>
      )}
      {feeLabel && (
        <p className="small mb-2">
          Register For <span className="fw-semibold">{feeLabel}</span>
        </p>
      )}
      <a href={registerUrl} className="btn btn-primary btn-sm w-100">
        Register
      </a>
    </div>
  );
}

export function UpcomingSeasonsCard({ seasons }) {
  if (!seasons?.length) return null;

  return (
    <div className="card mb-3">
      <div className="card-header pb-0 border-0">
        <h2 className="h5 card-title mb-0">Upcoming Seasons</h2>
      </div>
      <div className="card-body">
        {seasons.map((season, index) => (
          <RegistrationPromoCard
            key={season.id}
            season={season}
            showDivider={index < seasons.length - 1}
          />
        ))}
        <div className="text-center">
          <Link to="/leagues/seasons/select/" className="small link-secondary">
            View all open seasons
          </Link>
        </div>
      </div>
    </div>
  );
}

export default RegistrationPromoCard;
